import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor">
            <path
                fill="#75B8C8"
                d="M9.75 7.5h-7.5a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75Zm0 3.75h-7.5v-3h7.5v3Zm.75-6.75V1.655a.75.75 0 0 0-.22-.53L9.374.22C9.214.079 9.044 0 8.845 0H3a1.5 1.5 0 0 0-1.5 1.5v3C.673 4.5 0 5.173 0 6v2.625a.375.375 0 0 0 .75 0V6a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v2.625a.375.375 0 1 0 .75 0V6c0-.827-.673-1.5-1.5-1.5Zm-.75 0h-7.5v-3A.75.75 0 0 1 3 .75h5.845l.905.905V4.5Zm.375 1.313a.562.562 0 1 0 0 1.124.562.562 0 0 0 0-1.125Z"
            />
        </svg>
    );
};

export default React.memo(Print);
